import { initializeTooltips } from '../tooltips'

initializeTooltips()
